<script>
  import { getContext } from "svelte";

  import { computeTextDims } from "./chartUtils";

  const { width, xGet, yGet, zGet, height, x, data } = getContext("LayerCake");

  /** @type {Function | undefined} Formatter for x-axis values. */
  export let formatX = undefined;

  /** @type {Function | undefined} Formatter for y-axis values. */
  export let formatY = undefined;

  /** @type {string[]} */
  export let seriesNames = [];

  /** @type {number | undefined} The currently hovered index */
  export let hoveredIndex = undefined;

  let computeTextEl;
</script>

<!-- Invisible element, used for computing text widths. -->
<g class="invisible pointer-events-none" bind:this={computeTextEl} />

<!-- Tooltip elements -->
{#if computeTextEl && hoveredIndex !== undefined && hoveredIndex < $data[0].length}
  {@const item =
    $data[$data.length - 1][Math.min(hoveredIndex, $data[0].length - 1)]}
  {@const xPos = $xGet(item)}
  {@const yPos = $yGet(item)[1]}

  {@const xText = formatX ? formatX($x(item)) : $x(item)}
  {@const xTextDims = computeTextDims(
    computeTextEl,
    xText,
    "font-bold fill-white",
    {
      fontSize: "13px",
    },
  )}
  {@const xTextCenter =
    xPos -
    Math.max(xPos + xTextDims.width / 2 - 6 - $width, 0) -
    Math.min(xPos - xTextDims.width / 2 + 6, 0)}

  <!-- Place the tooltip left of the cursor when in the rightmost 25% of the chart. -->
  {@const reverseTooltip = xPos > $width * 0.75}

  <!-- Timestamp at the x-axis of the chart. -->
  <g transform="translate({xTextCenter} {$height})">
    <rect
      x={-xTextDims.width / 2 - 4}
      y={3}
      width={xTextDims.width + 8}
      height={xTextDims.height + 2}
      class="stroke-none fill-black/75"
    />
    <text
      y={4}
      text-anchor="middle"
      dominant-baseline="text-before-edge"
      style:font-size="13px"
      class="font-bold fill-white"
    >
      {xText}
    </text>
  </g>

  {#each seriesNames as series, i}
    {@const value = $data[i][hoveredIndex].data[series]}
    {@const yText = formatY ? formatY(value, series) : value}
    {@const yTextDims = computeTextDims(
      computeTextEl,
      yText,
      "font-bold fill-white",
      {
        fontSize: "13px",
      },
    )}
    {@const maxWidth = Math.max(
      ...seriesNames.map(
        (s) =>
          computeTextDims(
            computeTextEl,
            formatY ? formatY(value, s) : value,
            "font-bold fill-white",
            { fontSize: "13px" },
          ).width,
      ),
    )}
    <!-- Label and tooltip showing the y-value. -->
    <g
      class="pointer-events-none"
      transform="translate(
      {xTextCenter + (reverseTooltip ? -20 : 20)} {4 +
        (yPos < 24 ? 30 : 0) +
        i * yTextDims.height})"
    >
      <rect
        x={-4 + (reverseTooltip ? -maxWidth : 0)}
        y={-1}
        width={yTextDims.width + 20}
        height={yTextDims.height + 2}
        class="stroke-none fill-black/75"
      />
      <rect
        x={0 + (reverseTooltip ? -maxWidth : 0)}
        y={3}
        width={10}
        height={10}
        fill={$zGet($data[i])}
        class="stroke-none"
      />
      <text
        x={14 - (reverseTooltip ? maxWidth - yTextDims.width : 0)}
        dominant-baseline="text-before-edge"
        text-anchor={reverseTooltip ? "end" : "start"}
        style:font-size="13px"
        class="font-bold fill-white"
      >
        {yText}
      </text>
    </g>
  {/each}
{/if}
